import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import PropTypes from 'prop-types';
import { Table, Spin, Icon } from 'antd';
import { isEmpty } from '../../../util/isEmpty';
import { getOriginDischargeData } from '../../../util/getOriginDischargeData';
import { getPickupDeliveryErsOptionData } from '../../../util/getPickupDeliveryErsOptionData';
import { originDischargeSectionArr } from '../../../util/originDischargeSectionArr';
import { CHARGE_ROW } from '../../../util/getOriginDestinationCharges';
import EstimateBadge from './EstimateBadge';

// getOriginDischargeData display rows are [code, desc, price, isEstimate]; the flag is index 3
// (distinct from the raw source row where it is CHARGE_ROW.IS_ESTIMATE = 8).
const DISPLAY_ROW_IS_ESTIMATE = 3;

// A `fees` column renderer that appends the estimate badge when the row is flagged. Shared by the
// FCL/LCL/AIR column builders so the badge is wired in exactly one place.
const renderFeesWithEstimate = (value, record) => (
  <span>
    {value}
    <EstimateBadge show={record && record.isEstimate === true} />
  </span>
);

const styles = {
  background: {
    background: 'white',
  },
};


const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

//unit
// weight
const KG = 'KG';
const LBS = 'LBS';
// volume
const CBM = 'CBM';
const CFT = 'CFT';

// mode
const ORIGIN = 'origin';
const DISCHARGE = 'discharge';

// for json, mode section
const ORIGIN_SECTION = 'port_fees_from';
const DISCHARGE_SECTION = 'port_fees_to';

const ORIGIN_DESC = 'origin_description';
const DISCHARGE_DESC = 'discharge_description';

// get section
const getSection = (mode) => {
  let modeSection;
  if (mode === ORIGIN) {
    modeSection = ORIGIN_SECTION;
  } else if (mode === DISCHARGE) {
    modeSection = DISCHARGE_SECTION;
  }
  return modeSection;
};

const getDescription = (mode) => {
  let modeSection;
  if (mode === ORIGIN) {
    modeSection = ORIGIN_DESC;
  } else if (mode === DISCHARGE) {
    modeSection = DISCHARGE_DESC;
  }
  return modeSection;
};

/**
 * @component
 * @name RowTable
 * @category Search Page
 * @subcategory Rate Card
 * @description It renders a table in pickup/ers/delivery and origin/discharge section in view-details section
 * <br> <br>
 * **Example**
 * ```js
 *   <RowTable  dominantUnit footerData fclItem lclItem airItem mode checkboxData tableDataArr? selectedOption?/>
 * ```
 */
class RowTable extends Component {
  /**
   * @description It creates FCL table column data
   * <br> <br>
   * **getFCLColumn({_20stCounter, _40stCounter,_40hqCounter,_45hqCounter, }) -> {Array}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | _20stCounter  | number        | FCL 20 Standard container count   |
   * | _40stCounter  | number        | FCL 40 Standard container count   |
   * | _40hqCounter  | number        | FCL 40 High Cube container count  |
   * | _45hqCounter  | number        | FCL 45 High Cube container count  |
   * <br> <br>
   * Returns: table column data  **Type: Array**
   */
  getFCLColumn = ({
    _20stCounter,
    _40stCounter,
    _40hqCounter,
    _45hqCounter,
  }) => {
    const { fclItem, lclItem, airItem, mode, removeFcl45HcContainer } =
      this.props;
    let itemJson =
      (!isEmpty(fclItem) && fclItem) ||
      (!isEmpty(lclItem) && lclItem) ||
      (!isEmpty(airItem) && airItem) ||
      {};

    let rateArr = [];

    if (mode === ORIGIN || mode === DISCHARGE) {
      rateArr = itemJson[getSection(mode)];
      rateArr = Array.isArray(rateArr) ? rateArr : [];
    } else {
      rateArr =
        (Array.isArray(itemJson[getSection(mode)])
          ? itemJson[getSection(mode)][this.props.selectedOption] || {}
          : []
        ).rate || [];
    }

    const columns = [
      {
        title: '',
        dataIndex: 'fees',
        render: renderFeesWithEstimate,
        //width: 400,
      },
    ];

    if (_20stCounter > 0) {
      columns.push({
        title: '20 ST',
        dataIndex: '_20st',
        //width: 100,
        className: 'column-price',
        // render: (value, row, index) => {
        //   const obj = {
        //     children: value,
        //     props: {},
        //   };
        //   let rateRowArr = rateArr[index];
        //   rateRowArr = Array.isArray(rateRowArr) ? rateRowArr : [];

        //   // align left
        //   // obj.props.className = 'column-price';

        //   if (!rateRowArr[3]) {
        //     if (_40stCounter > 0 || _40hqCounter > 0) {
        //       obj.props.colSpan = 2;
        //       // obj.props.className = '';
        //     }
        //     if (_40stCounter > 0 && _40hqCounter > 0) {
        //       obj.props.colSpan = 3;
        //       // obj.props.className = '';
        //     }
        //   }
        //   return obj;
        // },
      });
    }
    if (_40stCounter > 0) {
      columns.push({
        title: '40 ST',
        dataIndex: '_40st',
        //width: 100,
        className: 'column-price',
        // render: (value, row, index) => {
        //   const obj = {
        //     children: value,
        //     props: {},
        //   };
        //   let rateRowArr = rateArr[index];
        //   rateRowArr = Array.isArray(rateRowArr) ? rateRowArr : [];

        //   // align left
        //   // obj.props.className = 'column-price';

        //   if (!rateRowArr[3]) {
        //     if (_20stCounter > 0) {
        //       obj.props.colSpan = 0;
        //       return obj;
        //     }

        //     if (_40hqCounter > 0) {
        //       obj.props.colSpan = 2;
        //       // obj.props.className = '';
        //     } else {
        //       obj.props.colSpan = 1;
        //     }
        //   }
        //   return obj;
        // },
      });
    }
    if (_40hqCounter > 0) {
      columns.push({
        title: '40 HQ',
        dataIndex: '_40hq',
        //width: 100,
        className: 'column-price',
        // render: (value, row, index) => {
        //   const obj = {
        //     children: value,
        //     props: {},
        //   };
        //   let rateRowArr = rateArr[index];
        //   rateRowArr = Array.isArray(rateRowArr) ? rateRowArr : [];

        //   // align left
        //   // obj.props.className = 'column-price';

        //   if (!rateRowArr[3]) {
        //     if (_20stCounter > 0) {
        //       obj.props.colSpan = 0;
        //       return obj;
        //     }
        //     if (_40stCounter > 0) {
        //       obj.props.colSpan = 0;
        //       return obj;
        //     }
        //   }
        //   return obj;
        // },
      });
    }

    if (!removeFcl45HcContainer && _45hqCounter > 0) {
      columns.push({
        title: '45 HQ',
        dataIndex: '_45hq',
        //width: 100,
        className: 'column-price',
        // render: (value, row, index) => {
        //   const obj = {
        //     children: value,
        //     props: {},
        //   };
        //   let rateRowArr = rateArr[index];
        //   rateRowArr = Array.isArray(rateRowArr) ? rateRowArr : [];

        //   // align left
        //   // obj.props.className = 'column-price';

        //   if (!rateRowArr[3]) {
        //     if (_20stCounter > 0) {
        //       obj.props.colSpan = 0;
        //       return obj;
        //     }
        //     if (_40stCounter > 0) {
        //       obj.props.colSpan = 0;
        //       return obj;
        //     }
        //     if (_40hqCounter > 0) {
        //       obj.props.colSpan = 0;
        //       return obj;
        //     }
        //   }
        //   return obj;
        // },
      });
    }
    return columns;
  };

  /**
   * @description It creates LCL table column data
   * <br> <br>
   * **getLCLColumn({ totalWeight, weightUnit, totalVolume, volumeUnit },dominantUnit) -> {Array}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | totalWeight   | number        | total weight  |
   * | weightUnit    | string        | weight unit   |
   * | totalVolume   | number        | total volume  |
   * | volumeUnit    | string        | volume unit  |
   * | dominantUnit  | string       | [dominant Unit]{@link module:util.getDominantUnit}. |
   * <br> <br>
   * Returns: table column data  **Type: Array**
   */
  getLCLColumn = (
    { totalWeight, weightUnit, totalVolume, volumeUnit },
    dominantUnit
  ) => {
    let weight;
    if (dominantUnit === CBM || dominantUnit === CFT) {
      weight = totalVolume;
    } else {
      weight = totalWeight;
    }
    const columns = [
      {
        title: '',
        dataIndex: 'fees',
        render: renderFeesWithEstimate,
        //width: 550,
      },
      {
        title: `${weight} ${dominantUnit}`,
        dataIndex: 'weight',
        className: 'column-price',
        //width: 150,
      },
    ];

    return columns;
  };

  /**
   * @description It creates AIR table column data
   * <br> <br>
   * **getAIRColumn({ totalWeight, weightUnit, totalVolume, volumeUnit },dominantUnit) -> {Array}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | totalWeight   | number        | total weight  |
   * | weightUnit    | string        | weight unit   |
   * | totalVolume   | number        | total volume  |
   * | volumeUnit    | string        | volume unit  |
   * | dominantUnit  | string       | [dominant Unit]{@link module:util.getDominantUnit}. |
   * <br> <br>
   * Returns: table column data  **Type: Array**
   */
  getAIRColumn = (
    { totalWeight, weightUnit, totalVolume, volumeUnit },
    dominantUnit
  ) => {
    let weight;
    if (dominantUnit === CBM || dominantUnit === CFT) {
      weight = totalVolume;
    } else {
      weight = totalWeight;
    }
    const columns = [
      {
        title: '',
        dataIndex: 'fees',
        render: renderFeesWithEstimate,
        //width: 550,
      },
      {
        title: `${weight} ${dominantUnit}`,
        dataIndex: 'weight',
        className: 'column-price',
        //width: 150,
      },
    ];

    return columns;
  };

  /**
   * @description It creates FCL table data
   * <br> <br>
   * **getFCLData() -> {Array}**
   * <br><br>
   * Returns: table data  **Type: Array**
   */
  // roll getFCLData back to previous version
  getFCLData = () => {
    //old process
    const {
      fclItem,
      lclItem,
      airItem,
      mode,
      fclCounters = {},
      removeFcl45HcContainer,
      checkboxData,
    } = this.props;

    let itemJson =
      (!isEmpty(fclItem) && fclItem) ||
      (!isEmpty(lclItem) && lclItem) ||
      (!isEmpty(airItem) && airItem) ||
      {};
    const { _20stCounter, _40stCounter, _40hqCounter, _45hqCounter } =
      fclCounters;
    // get table data arrya for a specific chargeable weight
    let _20stRateArr = [];

    let _40stRateArr = [];

    let _40hqRateArr = [];

    let _45hqRateArr = [];

    if (mode === ORIGIN || mode === DISCHARGE) {
      _20stRateArr = getOriginDischargeData(
        mode,
        itemJson,
        _20stCounter,
        checkboxData.delivery,
        { equipmentSizeType: '20ST' }
      ).tableDataArr;

      _40stRateArr = getOriginDischargeData(
        mode,
        itemJson,
        _40stCounter,
        checkboxData.delivery,
        { equipmentSizeType: '40ST' }
      ).tableDataArr;

      _40hqRateArr = getOriginDischargeData(
        mode,
        itemJson,
        _40hqCounter,
        checkboxData.delivery,
        { equipmentSizeType: '40HQ' }
      ).tableDataArr;

      _45hqRateArr = getOriginDischargeData(
        mode,
        itemJson,
        _45hqCounter,
        checkboxData.delivery,
        { equipmentSizeType: '45HQ' }
      ).tableDataArr;
    } else {
      // for pickup, ers, delivery sections
      const { selectedOption, tableDataArr = [] } = this.props;
      const hasOverrideTableData =
        Array.isArray(tableDataArr) && tableDataArr.length > 0;

      if (hasOverrideTableData) {
        _20stRateArr = tableDataArr;
        _40stRateArr = tableDataArr;
        _40hqRateArr = tableDataArr;
        _45hqRateArr = tableDataArr;
      } else {
        _20stRateArr = getPickupDeliveryErsOptionData(
          mode,
          selectedOption,
          itemJson,
          _20stCounter
        ).tableDataArr;

        _40stRateArr = getPickupDeliveryErsOptionData(
          mode,
          selectedOption,
          itemJson,
          _40stCounter
        ).tableDataArr;

        _40hqRateArr = getPickupDeliveryErsOptionData(
          mode,
          selectedOption,
          itemJson,
          _40hqCounter
        ).tableDataArr;

        _45hqRateArr = getPickupDeliveryErsOptionData(
          mode,
          selectedOption,
          itemJson,
          _45hqCounter
        ).tableDataArr;
      }
    }

    const data = [];

    let tempRateData = [];

    if (mode === ORIGIN || mode === DISCHARGE) {
      // tempRateData = itemJson[getSection(mode)];
      tempRateData = originDischargeSectionArr(
        mode,
        itemJson,
        checkboxData.delivery
      );
    } else {
      tempRateData = this.props.tableDataArr;
    }

    if (mode === ORIGIN || mode === DISCHARGE) {
      const rowsMap = new Map();
      Array.isArray(tempRateData) &&
        tempRateData.forEach((item, index) => {
          const dedupeKey = `${item[0]}_${item[1]}`;
          if (!rowsMap.has(dedupeKey)) {
            rowsMap.set(dedupeKey, {
              key: dedupeKey,
              fees: item[1],
              isEstimate: item[CHARGE_ROW.IS_ESTIMATE] === true,
              _20st: '',
              _40st: '',
              _40hq: '',
              ...(!removeFcl45HcContainer && { _45hq: '' }),
            });
          }
          const row = rowsMap.get(dedupeKey);
          // any duplicate line being an estimate marks the merged row as estimated
          if (item[CHARGE_ROW.IS_ESTIMATE] === true) row.isEstimate = true;
          const setValue = (arr, field) => {
            const value = (arr[index] || [])[2];
            if (value) {
              row[field] = `$ ${value}`;
            }
          };
          setValue(_20stRateArr, '_20st');
          setValue(_40stRateArr, '_40st');
          setValue(_40hqRateArr, '_40hq');
          if (!removeFcl45HcContainer) {
            setValue(_45hqRateArr, '_45hq');
          }
        });
      return Array.from(rowsMap.values());
    }

    Array.isArray(tempRateData) &&
      tempRateData.map((item, index) =>
        data.push({
          key: index,
          fees: item[1],
          isEstimate: item[DISPLAY_ROW_IS_ESTIMATE] === true,
          _20st: `$ ${(_20stRateArr[index] || [])[2] || ''}`,
          _40st: `$ ${(_40stRateArr[index] || [])[2] || ''}`,
          _40hq: `$ ${(_40hqRateArr[index] || [])[2] || ''}`,

          ...(!removeFcl45HcContainer && {
            _45hq: `$ ${(_45hqRateArr[index] || [])[2] || ''}`,
          }),
        })
      );

    return data;
  };

  /**
   * @description It creates LCL table data
   * <br> <br>
   * **getLCLData(tableDataArr) -> {Array}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | tableDataArr  | Array         | array of strings for one selected radio option table data  |
   * <br> <br>
   * Returns: table data  **Type: Array**
   */
  getLCLData = (tableDataArr) => {
    const data = [];

    Array.isArray(tableDataArr) &&
      tableDataArr.map((item, index) =>
        data.push({
          key: index,
          fees: item[1],
          weight: `$ ${item[2]}`,
          isEstimate: item[DISPLAY_ROW_IS_ESTIMATE] === true,
        })
      );
    return data;
  };

  /**
   * @description It creates AIR mode table data
   * <br> <br>
   * **getAIRData(tableDataArr) -> {Array}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | tableDataArr  | Array         | array of strings for one selected radio option table data  |
   * <br> <br>
   * Returns: table data  **Type: Array**
   */
  getAIRData = (tableDataArr) => {
    const data = [];
    Array.isArray(tableDataArr) &&
      tableDataArr.map((item, index) =>
        data.push({
          key: index,
          fees: item[1],
          weight: `$ ${item[2]}`,
          isEstimate: item[DISPLAY_ROW_IS_ESTIMATE] === true,
        })
      );
    return data;
  };

  /**
   * @description It creates table data for FCL/LCL/AIR mode
   * <br> <br>
   * **getTableData() -> {Array}**
   * <br><br>
   * Returns: table data  **Type: Array**
   */
  getTableData = () => {
    const { fclItem, lclItem, airItem, footerData, mode } = this.props;

    const { originTableObj = {}, dischargeTableObj = {} } = footerData;
    let tableDataArr = [];

    // check mode origin or discharge
    if (mode === ORIGIN) {
      tableDataArr = originTableObj.tableDataArr;
    } else if (mode === DISCHARGE) {
      tableDataArr = dischargeTableObj.tableDataArr;
    } else {
      tableDataArr = this.props.tableDataArr || [];
    }

    const data =
      (!isEmpty(fclItem) && this.getFCLData()) ||
      (!isEmpty(lclItem) && this.getLCLData(tableDataArr)) ||
      (!isEmpty(airItem) && this.getAIRData(tableDataArr)) ||
      [];

    return data;
  };

  render() {
    // prettier-ignore
    const { fclItem, lclItem, airItem,  mode } = this.props;
    // const { seaFCLJSON, seaLCLJSON, airJSON } = this.props;
    const { fclCounters, lclShipment, airShipment, dominantUnit, pickup_postal_code, delivery_postal_code } = this.props;

    const getColumn =
      (!isEmpty(fclItem) && this.getFCLColumn(fclCounters)) ||
      (!isEmpty(lclItem) && this.getLCLColumn(lclShipment, dominantUnit)) ||
      (!isEmpty(airItem) && this.getAIRColumn(airShipment, dominantUnit));

    let getData = this.getTableData();

    // console.log({ getData });

    let description = '';
    if (mode === ORIGIN || mode === DISCHARGE) {
      description =
        (!isEmpty(fclItem) && fclItem[getDescription(mode)]) ||
        (!isEmpty(lclItem) && lclItem[getDescription(mode)]) ||
        (!isEmpty(airItem) && airItem[getDescription(mode)]) ||
        '';
    }

    return (
        (this.props.sliderChange && ((pickup_postal_code && pickup_postal_code!== "" && (mode === "pickup" || mode === "origin"))
         || (delivery_postal_code && delivery_postal_code !== "" && (mode === "delivery" || mode === "discharge"))) )? 
        
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"100px"}}>
          <Spin
            indicator={antIcon}
            style={{
              marginLeft: '10px',
              marginRight: '10px',
            }}
          />
        </div>
      :
      <div style={styles.background} className="my-table-21a3741">
        <Table
          columns={getColumn}
          dataSource={getData}
          bordered={true}
          pagination={false}
        />
        {/* only for origin and discharge section */}
        {description.trim() && (
          <div style={{ fontSize: '12px', paddingLeft: '40px' }}>
            {description}
          </div>
        )}
      </div>
    );
  }
}

RowTable.propTypes = {
  /**
   * [FCL container]{@link FCLContainerType} counts on search page
   */
  fclCounters: PropTypes.object,
  /**
   *  [LCL shipment]{@link LclAirSlider} data on search page
   */
  lclShipment: PropTypes.object,
  /**
   * [AIR shipment]{@link LclAirSlider} data on search page
   */
  airShipment: PropTypes.object,
  /**
   * Whether to remove 45' HC from fcl container
   */
  removeFcl45HcContainer: PropTypes.bool,
  /**
   * fcl single rate card json
   */
  fclItem: PropTypes.object,
  /**
   * lcl single rate card json
   */
  lclItem: PropTypes.object,
  /**
   * air mode single rate card json
   */
  airItem: PropTypes.object,
  /**
   * it contains view-details section different rates,
   * options data for pickup/delivery/ers,
   * info about origin/discharge section
   */
  footerData: PropTypes.object,
  /**
   * It's the [dominant Unit]{@link module:util.getDominantUnit}. It's only for LCL and AIR mode.
   */
  dominantUnit: PropTypes.string,
  /**
   * on which mode it is used i.e.`pickup` or `ers` or `delivery` or `discharge` or `origin`
   */
  mode: PropTypes.string,
  /**
   * checkbox states in view-details section
   * i.e. `{ pickup: true, origin: false,freight: true,discharge: false,ers: false, delivery: false, }`
   * `true` - checkbox is checked. `false` - checkbox is unchecked
   */
  checkboxData: PropTypes.object,

  /**
   * array of strings for one selected radio option table data.
   * This is only for pickup/ers/delivery section, not for origin/discharge/freight section in view-details section
   */
  tableDataArr: PropTypes.array,
  /**
   * selected radio option.
   * This is only for pickup/ers/delivery section, not for origin/discharge/freight section in view-details section
   */
  selectedOption: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    fclCounters: state.code_config.fclCounters,
    lclShipment: state.code_config.lclShipment,
    airShipment: state.code_config.airShipment,
    removeFcl45HcContainer: state.code_config.removeFcl45HcContainer,
    sliderChange: state.form.sliderChange,
    pickup_postal_code: state.route.pickup_postal_code,
    delivery_postal_code:  state.route.delivery_postal_code,
  };
};

export default connect(mapStateToProps, actions)(RowTable);
